<template>
    <div>
        <PageTitle :title="$t('Notifications')"/>
        <div v-if="!initialLoading" :key="language">
            <div v-if="generalNotifications.length">
                <div v-for="notification in generalNotifications" :key="notification.id">
                    <!--Handle all kinds of types and usecases -->
                    <DiaryLikeNotification v-if="notification.type === 'diary_like'" :notification="notification"/>
                    <ApprovalsSubmitNotification v-else-if="notification.type === 'approvals_submit'" :notification="notification"/>
                    <div v-else-if="notification.type === 'calendar'" class="card p-3 mb-2">
                        <ChildCalendarNotification :notification="notification"/>
                    </div>
                    <div v-else-if="notification.type === 'wishlist'" class="card p-3 mb-2">
                        <KindergartenWishlistNotification :notification="notification"/>
                    </div>
                    <div v-else-if="notification.type === 'application'" class="card p-3 mb-2">
                        <ApplicationNotification :notification="notification"/>
                    </div>
                    <div v-else-if="notification.type === 'new_survey'">
                        <SurveyNotification :notification="notification"/>
                    </div>
                    <div v-else-if="notification.type === 'card_comment'" class="card p-3 mb-2">
                        <CommentNotification :notification="notification"/>
                    </div>
                </div>
                <div v-if="hasMoreNotifications" class="d-flex mt-3">
                    <EBtnLoader :is-submit-loading="isSubmitLoading" color="primary" class="mx-auto" @clicked="loadMore">
                        {{$t('Load more')}}
                    </EBtnLoader>
                </div>
            </div>
            <EmptyListMessage v-else wrapper-class="border rounded bg-white p-3 mt-3">
                {{$t('There are no notifications')}}
            </EmptyListMessage>
        </div>
        <ELoader v-else class="overlay-loader"/>
    </div>

</template>

<script>
import {mapGetters} from 'vuex';
import ApplicationNotification from '@/views/notification/components/ApplicationNotification.vue';
import ChildCalendarNotification from '@views/notification/components/ChildCalendarNotification';
import DiaryLikeNotification from '@/views/notification/components/DiaryLikeNotification.vue';
import KindergartenWishlistNotification from '@/views/notification/components/KindergartenWishlistNotification.vue';
import ApprovalsSubmitNotification from '@/views/notification/components/ApprovalsSubmitNotification.vue';
import SurveyNotification from '@/views/notification/components/SurveyNotification.vue';
import CommentNotification from '@/views/notification/components/CommentNotification.vue';

export default {
    name: 'Notifications',
    data() {
        return {
            page: 1,
            perPage: 5,
            initialLoading: true,
            isSubmitLoading: false
        };
    },
    computed: {
        ...mapGetters(['generalNotifications', 'hasMoreNotifications', 'user', 'language'])
    },
    methods: {
        loadMore() {
            this.page++;
            this.isSubmitLoading = true;
            this.getNotifications();
        },
        getNotifications() {
            this.$store.dispatch('GET_NOTIFICATIONS', {page: this.page, perPage: this.perPage}).then(() => {
                if(this.page === 1) {
                    this.$store.commit('SET_RECENT_NOTIFICATIONS_COUNT', 0);
                }
            }).finally(() => {
                this.initialLoading = false;
                this.isSubmitLoading = false;
            });
        }
    },
    components: {
        SurveyNotification,
        ApprovalsSubmitNotification,
        ApplicationNotification,
        ChildCalendarNotification,
        DiaryLikeNotification,
        KindergartenWishlistNotification,
        CommentNotification
    },
    created() {
        this.getNotifications();
    }
};
</script>

<style lang="scss" scoped>
@import "@common/styles/components/_notifications.scss";
</style>
